const translations = {
  "en": {
    "Comparison:": "Comparison:",
    "No historical data": "No historical data"
  },
  "zh-tw": {
    "Comparison:": "對比：",
    "No historical data": "沒有歷史資料"
  }
};

export default translations;
